import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import {ApiBaseUrl} from '../../constants';
import { AuthContext } from "./../../context/auth";
import { withSnackbar } from 'react-simple-snackbar';

class ForgotPasswordComponent extends Component{
    static contextType = AuthContext;
    state = {
        email : '',
        phonedata : {phone:'',value:''}
    }

    handleNameChange = (event) => {
        const {name,value} = event.target;
        this.setState({
            [name] : value
        })
    }

    handlePhoneNumber = (status, value, countryData, number, id) => {
        this.setState({
            phonedata: {
                phone: number,
                value: value
            }
        })
    }

    handleCountryChange = (value, countryData, number) => {
        this.setState({
            phonedata: {
                phone: number,
                value: value
            }
        })
    }

    handleFormSubmit = (event) => {
        event.preventDefault();
        const phone = this.state.phonedata.phone.trim();
        const value = this.state.phonedata.value;
        const phone_number = phone.replace('-','').replace(' ','').replace('-','');
        if ((this.state.phonedata.value === '' || phone_number.trim() === '' || value === '') && this.state.email==='')
            this.props.openSnackbar('Enter email address or phone number to request forgot password.')
        else {
            let formBody=''
            if(this.state.email!=='')
                formBody = "email=" + encodeURIComponent(this.state.email);
            else
                formBody = "phone=" + encodeURIComponent(phone_number);
            fetch(ApiBaseUrl + "/consumer/forgot_password",
                {
                    method: 'POST',
                    body: formBody,
                    headers:
                        {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        if(result.success)
                            this.props.history.push({ pathname: process.env.PUBLIC_URL+'/login', state: { phone_number: phone_number }});
                        this.props.openSnackbar(result.message)
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.props.openSnackbar('Oops, something went wrong.')
                    }
                )
        }

    }

    componentDidMount(){
        window.scrollTo(0, 0)
        document.getElementById('body').className='forgot-password'
    }

    componentWillUnmount() {
        document.getElementById('body').className=''
    }

    render(){
        return(
            !this.context.authenticated ?
            <React.Fragment>
                <div className="choose-deals-outer p-l-0 p-r-0 forgot-password-outer">
                    <div className="container">
                        <div className="col-md-10 col-lg-5 mx-auto">
                            <form autoComplete="off" onSubmit={this.handleFormSubmit} className="forgotpswd-form p-4">
                                <h4 className="text-white text-center d-block green-color font-weight-bold">Forgot
                                    Password</h4>
                                <label className="forgotpswd-label">Please enter the email address or phone number you used to register</label>
                                <div className="changepswd-rows mb-4">
                                    <label>Email Address</label>
                                    <div className="eye">
                                        <input type="email" className="form-control" name="email" onChange={this.handleNameChange} value={this.state.email}/>
                                    </div>
                                </div>
                                <label className="forgotpswd-label mb-4">OR</label>
                                <label className="forgotpswd-label mb-1 d-block">Mobile Number</label>
                                <div className="changepswd-rows text-center">
                                    <IntlTelInput
                                        fieldName="phone"
                                        inputClassName="form-control forgotpswd__input w-100"
                                        defaultValue={this.state.phonedata.phone}
                                        onPhoneNumberChange={this.handlePhoneNumber}
                                        onSelectFlag={this.handleCountryChange}
                                        separateDialCode="true"
                                        placeholder="Mobile Number"
                                        defaultCountry={'us'}
                                        useMobileFullscreenDropdown={false}
                                        preferredCountries={['us']}
                                        onlyCountries={['us', 'gb', 'au']}
                                    />
                                    <div className="btn-rowstack d-flex justify-content-end">
                                        <button className="entry-btn cancel-btn grad-on d-none d-lg-block next-btn"
                                                type="submit">Next
                                        </button>

                                        <button className="entry-btn grad-on d-lg-none" type="submit"><img src={`${process.env.PUBLIC_URL}/image/back_white.png`} alt=""/></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </React.Fragment> :
        <Redirect to={{ pathname: process.env.PUBLIC_URL+'/', state: { from: this.props.location } }} />
        )
    }
}

export default withSnackbar(ForgotPasswordComponent,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});